
<secondary-header>
  <template #left>
    <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
    <template v-if="isFromDashboard">
      <a class="btn-link" :href="goBackToDashboardUrl">Go back to dashboard.</a>
    </template>
  </template>
  <template #right>
    <list-view-actions
      :list-view="selectedPublishedListView.listView">
    </list-view-actions>
    <button
      v-if="isNotOneStop && $can('exportCSV', selectedPublishedListView)"
      @click="showExportModal"
      class="btn blue"
    >
      Export
    </button>

    <confirmation-modal
      v-if="modalStateFor(vueModalID.confirmObjectModelAction).isVisible"
      :state="modalStateFor(vueModalID.confirmObjectModelAction)"
      :index="vueModalID.confirmObjectModelAction"
      @toggle-modal="handleCloseConfirmationModal"
      :overrideConfig="actionConfirmationModalConfig"
    >
    </confirmation-modal>

    <list-view-export-modal
      v-if="modalStateFor(vueModalID.exportListViewModal, ModalStatus.Confirmation).isVisible"
      :state="modalStateFor(vueModalID.exportListViewModal)"
      :config="exportConfig"
      :index="vueModalID.exportListViewModal"
      @toggle-modal="resetExportListViewModal"
      @tryExport="tryExport"
      @fail="goToFailure"
      @success="goToSuccess"
      @retry="goToExporting"
    ></list-view-export-modal>
  </template>
</secondary-header>
